export const inputs = [
  {
    advanced: false,
    type: 'select',
    id: 'visible',
    label: 'Status',
    value: '',
    options: [
      {
        label: 'Desativado',
        value: '0'
      },
      {
        label: 'Ativado',
        value: '1'
      }
    ]
  },
  {
    advanced: false,
    type: 'input',
    id: 'name',
    label: 'Nome',
    value: ''
  }
];